import stock from '@/api/stock';
import * as types from './mutationTypes';

export default {
  fetchDistricts({ commit }) {
    commit(types.START_FETCH_DISTRICTS);
    stock.getDistricts().then((districts) => {
      commit(types.SET_FETCHED_DISTRICTS, districts);
    })
      .catch((e) => {
        commit(types.FETCH_DISTRICTS_ERROR, `failed get districts: ${e}`);
      });
  },

  setIcsType({ commit }, payload) {
    commit(types.SET_ICS_TYPE, payload);
  },
};
